import React, { useState } from "react";
import { useIntl } from "react-intl";
import axios from "axios";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Grid, Box } from "@material-ui/core";
import { useDispatch } from "react-redux";
import translate from "i18n/translate";
import { toast } from "react-toastify";
import useStyles from "./transferBetweenUsersStyles";
import { startFundsAutoUpdate } from "redux/app/actions/funds.action";
import {
  SrAlert,
  SrButton,
  SrCurrencyInput,
  SrInput,
} from "../../../../common";
import { U2U_TRANSFER_BTW_USERS } from "../../../../../constants/api";
import { validations } from "utils";

const TransferBetweenUsersForm = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [error, setError] = useState();

  const validationSchema = Yup.object().shape({
    destinationEmail: validations.email.required(
      translate("common.requiredField")
    ),
    amount: validations.amountWithMin.required(
      translate("common.requiredField")
    ),
    concept: Yup.string().required(translate("common.requiredField")),
  });

  const initialValues = {
    destinationEmail: "",
    amount: "",
    concept: "",
  };

  const onSubmit = async (values) => {
    const { destinationEmail, amount, concept } = values;
    setError();

    try {
      await axios.post(
        U2U_TRANSFER_BTW_USERS,
        {
          email_dst: destinationEmail,
          amount,
          concept,
        },
        {
          "Content-Type": "application/json",
        }
      );
      toast.success(intl.formatMessage({ id: "transferBtwUsers.success" }));
      dispatch(startFundsAutoUpdate(true));
    } catch (error) {
      setError(
        error.response?.data?.error?.message ||
          error.message ||
          intl.formatMessage({ id: "errors.somethingWrong" })
      );
    }
  };

  return (
    <div className={classes.container}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          errors,
          handleSubmit,
          handleBlur,
          handleChange,
          touched,
          values,
          isSubmitting,
        }) => (
          <Form onSubmit={handleSubmit} className={classes.form}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SrInput
                  label={intl.formatMessage({
                    id: "transferBtwUsers.destinationEmail.label",
                  })}
                  placeholder={intl.formatMessage({
                    id: "transferBtwUsers.destinationEmail.placeholder",
                  })}
                  name="destinationEmail"
                  type="text"
                  value={values.destinationEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(
                    errors.destinationEmail && touched.destinationEmail
                  )}
                  helperText={
                    touched.destinationEmail && errors.destinationEmail
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <SrCurrencyInput
                  label={intl.formatMessage({
                    id: "transferBtwUsers.amount.label",
                  })}
                  placeholder={intl.formatMessage({
                    id: "transferBtwUsers.amount.placeholder",
                  })}
                  name="amount"
                  value={values.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(errors.amount && touched.amount)}
                  helperText={touched.amount && errors.amount}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <SrInput
                  label={intl.formatMessage({
                    id: "transferBtwUsers.concept.label",
                  })}
                  placeholder={intl.formatMessage({
                    id: "transferBtwUsers.concept.placeholder",
                  })}
                  name="concept"
                  type="text"
                  value={values.concept}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(errors.concept && touched.concept)}
                  helperText={touched.concept && errors.concept}
                  fullWidth
                />
              </Grid>
              {error && (
                <Grid item xs={12}>
                  <SrAlert severity="error">{error}</SrAlert>
                </Grid>
              )}
              <Grid item xs={12}>
                <Box mt={4}>
                  <SrButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                  >
                    {translate("common.send")}
                  </SrButton>
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TransferBetweenUsersForm;
